import React from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import Svg from '_assets/svg';
import styled from 'styled-components';
import { PersonalData } from './MenuData';
import Wrapper from './Wrapper';
import MenuSidebar from './MenuSidebar';

const Label = styled.span`
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    color: #FFE9F0;
`;

const Sidebar = () => {
  const location = useLocation();
  const history = useHistory();
  return (
    <Wrapper>
      <Link to="/" className="fsize-14 fweight-500 cl-grey-deep text-decoration-none d-flex align-items-center mb-4">
        <img src={Svg.arrow_left.default} className="mx-1" alt='checvron-lef' style={{ transform: 'rotate(226deg)', color: 'white' }} />
        <Label className="ms-2 mb-0">
          Back to home
        </Label>
      </Link>
      {
        PersonalData.map(val => {
          return (
            <MenuSidebar
              id={val.id}
              onClick={() => history.push(val.id)}
              data={val.data}
              key={val.id}
              title={val.title}
              icon={val.svg}
              iconActive={val.svg_active}
              active={location.pathname.indexOf(val.id) >= 0}
            />
          )
        })
      }
      {/* <Label className="margin-inline-20" style={{ marginTop: 20 }}>Organization</Label>
      {
        OrganizationData.map(val => {
          return (
            <MenuSidebar
              id={val.id}
              onClick={() => history.push(val.id)}
              data={val.data}
              key={val.id}
              title={val.title}
              icon={val.svg}
              iconActive={val.svg_active}
              active={location.pathname.indexOf(val.id) >= 0}
            />
          )
        })
      } */}
    </Wrapper>
  )
}

export default Sidebar;